<div class="meeting-owners-card">
  <div class="card-header">
    <h3>{{ 'MEETING_SETUP.MEETING_OWNERS.TITLE' | translate }}</h3>
    <p>{{ 'MEETING_SETUP.MEETING_OWNERS.DESCRIPTION' | translate }}</p>
  </div>

  <ul class="meeting-owners">
    @for (user of meeting.users; track user.id) {
      <li class="meeting-owner">
        <app-avatar [input]="user | userName" size="small"></app-avatar>
        <div class="identity">
          <span class="name">
            {{ user | userName }}
            @if (user.id === currentUserId) {
              <span class="you">({{ 'MEETING_SETUP.MEETING_OWNERS.YOU' | translate }})</span>
            }
          </span>
          <span class="email">{{ user.email }}</span>
        </div>
        @if (canManage && user.id !== currentUserId) {
          <span [matTooltip]="isLastMeetingOwner ? ('MEETING_SETUP.MEETING_OWNERS.LAST_MEETING_OWNER' | translate) : ''">
            <button
              mat-icon-button
              class="remove-button"
              [attr.aria-label]="'MEETING_SETUP.MEETING_OWNERS.REMOVE' | translate: { userName: user | userName }"
              [matTooltip]="isLastMeetingOwner ? '' : ('MEETING_SETUP.MEETING_OWNERS.REMOVE' | translate: { userName: user | userName })"
              [disabled]="isLastMeetingOwner || (removeMeetingOwnerMutation.result$ | async)?.isPending"
              (click)="removeMeetingOwner(user)"
            >
              <mat-icon>person_remove</mat-icon>
            </button>
          </span>
        }
      </li>
    }
  </ul>

  @if (canManage) {
    @if (teamUsers$ | async; as teamUsers) {
      <div class="add-meeting-owner-row">
        <mat-form-field appearance="outline" class="user-input" subscriptSizing="dynamic">
          <mat-label>{{ 'MEETING_SETUP.MEETING_OWNERS.ADD_PLACEHOLDER' | translate }}</mat-label>
          <input matInput name="meeting-owner" autocomplete="off" [(ngModel)]="filter" [matAutocomplete]="auto" />
          <mat-autocomplete #auto="matAutocomplete">
            @for (user of addableUsers(teamUsers); track user.id) {
              <mat-option [value]="describeUser(user)">{{ describeUser(user) }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button
          mat-stroked-button
          type="button"
          [disabled]="selectedUser(teamUsers) === null || (addMeetingOwnerMutation.result$ | async)?.isPending"
          (click)="addMeetingOwner(selectedUser(teamUsers))"
        >
          {{ 'COMMON.ADD' | translate }}
        </button>
      </div>
    }
  }
</div>
